<div class="p-40" style="display: flex; justify-content: space-between;">

  <ng-container *ngIf="cursorPosition$ | async as cursorPosition">
    <div *ngFor="let indexBlock of dayService.index$ | async; index as x">
      <div class="mb-15 menu-topic-header">{{ indexBlock.title }}</div>
      <div *ngFor="let vm of indexBlock.vms; index as y"
           class="menu-topic"
           [class.menu-topic--empty]="!vm.entry"
           [class.menu-topic--highlight]="x === cursorPosition.x && y === cursorPosition.y">
        {{ vm.topic.name }}
      </div>
    </div>
  </ng-container>

</div>

<ion-footer class="p-40">
  <div class="menu-topic"
       (click)="exit()">
    Close Writer | {{lastKey}}
  </div>
</ion-footer>
